<template>
  <v-app>
    <VitePwaManifest />
    <v-app-bar :title="`SATO48-2026 Online Screening`" />
    <slot />
    <NotifySnackbar />
  </v-app>
</template>

<script setup lang="ts">
useHead({
  titleTemplate: title => {
    return title
      ? `${title} - SATO48-2026 Online Screening`
      : 'SATO48-2026 Online Screening'
  },
})
</script>
